import {removeEmpty} from "../removeEmpty";
import {retry} from "../retry";

export interface EventProperties {
  [key: string]: any;
}

export interface EventConfig {
  anonymousId?: string;
}

const SLACK_WHITELIST_EVENTS = ['Shop Signup', 'First Product Created'];

function trackSegment(eventName: string, props?: EventProperties, config?: EventConfig): void {
  //@ts-ignore
  if (typeof analytics === 'undefined') return;

  //@ts-ignore
  console.debug(`Sending Segment Event [${eventName}]`, props);

  retry(
    async () => {
      //@ts-ignore
      analytics
        .track(eventName, props, removeEmpty({
          integrations: {
            All: true,
            Slack: SLACK_WHITELIST_EVENTS.includes(eventName),
          },
          anonymousId: config?.anonymousId
        }))
    }, {
      delayMs: 500,
      maxAttempts: 5,
      maxTimeMs: 5000
    });

}

export default function trackEvent(eventName: string, props?: EventProperties, config?: EventConfig): void {
  trackSegment(eventName, props);
}

export function trackPage(pageName?: string, props?: EventProperties, config?: EventConfig): void {
  //@ts-ignore
  if (typeof analytics === 'undefined') return;
  if (pageName) {
    //@ts-ignore
    analytics.page(pageName, props, removeEmpty({
      anonymousId: config?.anonymousId
    }));
  } else {
    //@ts-ignore
    analytics.page(props, removeEmpty({
      anonymousId: config?.anonymousId
    }));
  }
}

export function trackUser(id?: string, props: EventProperties = {}, config?: EventConfig): void {
  //@ts-ignore
  if (typeof analytics === 'undefined') return;

  if (id) {
    //@ts-ignore
    analytics.identify(id, props, removeEmpty({
      anonymousId: config?.anonymousId
    }));
  } else {
    //@ts-ignore
    analytics.identify(props, removeEmpty({
      anonymousId: config?.anonymousId
    }));
  }
}
